import { ChatGptMediaType } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const ChatGptMediaContentTypeSchema = createEnum(ChatGptMediaType);

const ChatGptListingMediaSchema_ = z.object({
  url: z.string(),
  contentType: ChatGptMediaContentTypeSchema,
});
export const ChatGptListingMediaSchema: z.ZodType<ChatGptListingMedia> =
  ChatGptListingMediaSchema_;
export interface ChatGptListingMedia
  extends z.infer<typeof ChatGptListingMediaSchema_> {}
